import { defineStore } from 'pinia'
import { api, socket } from '@dpgradio/creative'
import { configuration } from '@dpgradio/creative'

export const useLocationStore = defineStore('location', {
  state: () => ({
    trackers: {},
    // uuid -> { enabled, message }; a missing entry means the tracker is considered enabled
    status: {},
  }),

  actions: {
    async initTrackers(trackers) {
      this.listenToSockets(trackers)
      await this.fetchTrackers(trackers)
    },

    applyStatus(uuid, payload) {
      const enabled = [payload?.enabled, payload?.data?.enabled].find((value) => typeof value === 'boolean')
      if (enabled === undefined) return

      this.status[uuid] = {
        enabled,
        message: payload.message_when_disabled ?? payload.data?.message_when_disabled ?? '',
      }
    },

    async fetchTrackers(trackers) {
      this.trackers = Object.fromEntries(
        await Promise.all(
          trackers.map(async ({ uuid, type }) => {
            if (type === 'locationTracker') {
              const locations = await api.request().get(`/location_trackers/${uuid}/locations?limit=1`)
              return [uuid, locations]
            } else {
              const liveLocation = await api.request().get(`/live_locations/${uuid}`)
              this.applyStatus(uuid, liveLocation)
              const location = liveLocation.active_tracker?.most_recent_location
              return [uuid, location ? [location] : []]
            }
          })
        )
      )
    },

    listenToSockets(trackers) {
      const locationTrackers = trackers.filter(({ type }) => type === 'locationTracker')
      const liveLocations = trackers.filter(({ type }) => type === 'liveLocation')

      if (locationTrackers.length) {
        const stationSocket = socket.connect(configuration.stationId)
        locationTrackers.forEach(({ uuid }) =>
          stationSocket
            .subscribe({ location_tracker: uuid })
            .on('new_location', (data) => this.trackers[uuid].unshift(data.location))
            .on('status_changed', (data) => this.applyStatus(uuid, data))
        )
      }

      liveLocations.forEach(({ uuid }) => {
        socket.join(
          {
            station: configuration.stationId,
            entity: { live_location: uuid },
            action: 'location',
            options: { backlog: 1 },
          },
          ({ location }) => this.trackers[uuid].unshift(location)
        )
        socket.join(
          { station: configuration.stationId, entity: { live_location: uuid }, action: 'status_changed' },
          (data) => this.applyStatus(uuid, data)
        )
      })
    },
  },
})
